import React, { useState } from "react";
import { BsSlack } from "react-icons/bs";
import { CiLock } from "react-icons/ci";
import ScoreModal from "../modals/ScoreModal";

const Scores = () => {
  const [open, setOpen] = useState(false);
  const modalHandler = (e) => {
    setOpen(!open);
  };
  return (
    <>
      <button
        onClick={modalHandler}
        className="flex flex-row justify-between w-full hover:bg-gray-100"
      >
        <div className="flex items-center px-2 h-12 hover:text-blue-600 font-medium">
          <BsSlack />
          <div className="ml-2 text-sm">Scores</div>
        </div>
        <div className="m-4 text-blue-600">
          <CiLock />
        </div>
      </button>
      <ScoreModal open={open} onClose={modalHandler} />
    </>
  );
};

export default Scores;
